export enum TicketStatus {
    REDEEMED = "REDEEMED",
    ACTIVE = "ACTIVE",
    EXPIRED = "EXPIRED"
}

export interface IVouchersFilter {
    searchText: string
    status: TicketStatus | ''
}

export const initialClientPanelVouchersFilterState: IVouchersFilter = {
    searchText: "",
    status: ''
}